import EventShutterbugPermissions from './EventShutterbugPermissions';

export default EventShutterbugPermissions;
